import { drawCategoryTypeIds, drawPositionTypeIds } from './eventConstants';
import { shouldDisplayRoundNumbersV2 } from './events';
import { OutComeTypes } from './postScoreConstants';

export const getMatchPositionDisplay = (round, eliminationTypeId, matchPosition) => {
    if (eliminationTypeId && shouldDisplayRoundNumbersV2(eliminationTypeId)) {
        return `Rd ${round.number} / M ${matchPosition}`;
    }
    const matchCount = round.matches.length;
    if (matchCount === 1) {
        return `F / M ${matchPosition}`;
    }
    if (matchCount === 2) {
        return `SF / M ${matchPosition}`;
    }
    if (matchCount === 4) {
        return `QF / M ${matchPosition}`;
    }
    return `Rd ${round.number} / M ${matchPosition}`;
};

export const getPlayerRatings = (player) => {
    const doublesPkbRatingDisplay = player?.doublesPkbRatingDisplay?.pkbRating ? player.doublesPkbRatingDisplay?.pkbRating : 'UR';
    return player?.singlesPkbRatingDisplay?.pkbRating ? player.singlesPkbRatingDisplay?.pkbRating : doublesPkbRatingDisplay;
};

export const getPrintCardType = (scoreSheetType, scoringFormat) => {
    let type = '';
    const twoThreeScoringFormatTypes = [9, 10, 16, 17];
    if (scoreSheetType === 'official') {
        type = 'official-single';
        if (twoThreeScoringFormatTypes.indexOf(parseInt(scoringFormat)) > -1) {
            type = 'official-two-three';
        }
    } else if (scoreSheetType === 'simple') {
        type = 'simple';
        if (twoThreeScoringFormatTypes.indexOf(parseInt(scoringFormat)) > -1) {
            type = 'simple-two-three';
        }
    }
    return type;
};

export const getMatchCourtDisplay = (matchCourt, locationData) => {
    let matchCourtDisplay = 'NA';
    let locationName;
    let courtName;
    if (matchCourt) {
        if (matchCourt.locationId || matchCourt.facilityId || matchCourt.courtId) {
            (locationData || []).forEach(loc => {
                if (loc.id === matchCourt.locationId) {
                    locationName = loc.name;
                    loc.facilities.forEach(fac => {
                        if (fac.id === matchCourt.facilityId) {
                            fac.courts.forEach(c => {
                                if (c.id === matchCourt.courtId) {
                                    courtName = c.name;
                                }
                            });
                        }
                    });
                }
            });
            if (!locationName) {
                matchCourtDisplay = 'Loading...';
            } else {
                matchCourtDisplay = courtName;
            }
        }
    }
    return matchCourtDisplay;
};

export const getDisplayName = (position, playerData, teamData) => {
    let player = '';
    let team = '';
    let teamMemberOne = '';
    let teamMemberTwo = '';
    let firstDisplayName = 'NA';
    let secondDisplayName = 'NA';

    if (position?.typeId === drawPositionTypeIds.BYE) {
        firstDisplayName = 'Bye';
        secondDisplayName = 'Bye';
    } else if (position?.typeId === drawPositionTypeIds.PLAYER) {
        player = playerData.find(player => player.memberId === position?.memberId);
        firstDisplayName = `${player?.firstName} ${player?.lastName}, ${getPlayerRatings(player)}`;
    } else if (position?.typeId === drawPositionTypeIds.TEAM) {
        team = teamData?.find(team => team.id === position?.teamId);
        teamMemberOne = playerData.find(player => player.memberId === team.members[0]);
        teamMemberTwo = playerData.find(player => player.memberId === team.members[1]);
        firstDisplayName = `${teamMemberOne?.firstName} ${teamMemberOne?.lastName}, ${getPlayerRatings(teamMemberOne)}`;
        secondDisplayName = `${teamMemberTwo?.firstName} ${teamMemberTwo?.lastName}, ${getPlayerRatings(teamMemberTwo)}`;
    }

    return {
        firstDisplayName,
        secondDisplayName,
    };
};

const getDraw = (currentDraw, draws) => {
    let finalDraw = currentDraw;

    draws.forEach(draw => {
        if (draw.childDraws?.length) {
            draw.childDraws.forEach(childDraw => {
                if (childDraw.id === currentDraw.id) {
                    finalDraw = childDraw;
                    finalDraw.parentDrawName = draw.name;
                }
            });
        }
    });

    return finalDraw;
};

export const getDrawName = (currentDraw, allDraws) => {
    const foundDraw = getDraw(currentDraw, allDraws);

    if (foundDraw?.parentDrawName) {
        const { categoryTypeId } = foundDraw;
        let categoryType = '';
        if (categoryTypeId === drawCategoryTypeIds.BACK_DRAW) {
            categoryType = 'Backdraw';
        } else if (categoryTypeId === drawCategoryTypeIds.CONSOLATION) {
            categoryType = 'Consolation';
        } else if (categoryTypeId === drawCategoryTypeIds.THREEFOURPLAYOFF) {
            categoryType = '3-4 Playoff';
        } else if (categoryTypeId === drawCategoryTypeIds.FIVESIXPLAYOFF) {
            categoryType = '5-6 Playoff';
        } else {
            categoryType = currentDraw.name;
        }
        return `${foundDraw.parentDrawName}, ${categoryType}`;
    }
    return foundDraw?.name;
};

export const getPointToDisplayTriangle = (scoringFormat) => {
    const scoringFormatTypeIdsToDisplayTriangleAtPointSix = [4, 9, 11, 16];
    const scoringFormatTypeIdsToDisplayTriangleAtPointEight = [5, 6, 10, 12, 13, 17];
    const scoringFormatTypeIdsToDisplayTriangleAtPointEleven = [7, 8, 14, 15];

    if (scoringFormatTypeIdsToDisplayTriangleAtPointSix.indexOf(parseInt(scoringFormat)) > -1) {
        return 6;
    }

    if (scoringFormatTypeIdsToDisplayTriangleAtPointEight.indexOf(parseInt(scoringFormat)) > -1) {
        return 8;
    }

    if (scoringFormatTypeIdsToDisplayTriangleAtPointEleven.indexOf(parseInt(scoringFormat)) > -1) {
        return 11;
    }

    return 0;
};

export const matchHasWinner = (match) => {
    if (!match.result) {
        return false;
    }

    if (match.result.isWinner) {
        return true;
    }

    const winningOutcomes = [
        OutComeTypes.COMPLETED,
        OutComeTypes.RETIRED,
        OutComeTypes.WITHDREW,
        OutComeTypes.DEFAULTED,
        OutComeTypes.FORFEIT,
    ];
    return winningOutcomes.includes(match.result.outcome);
};

export const isMatchInComplete = (match) => {
    const inCompleteOutcomes = [
        OutComeTypes.INCOMPLETE,
    ];
    return match.result && inCompleteOutcomes.includes(match.result.outcome);
};

export const hasPositionWon = (match, positionType = 'positionOne') => {
    if (match.result) {
        const positionMembersParam = `${positionType}Members`;
        const positionMembers = match[positionMembersParam];

        const isWinner1InPositionMembers = positionMembers.find(member => {
            return member.playerId === match.result?.winner1Id;
        });
        const isWinner2InPositionMembers = positionMembers.find(member => {
            return member.playerId === match.result?.winner2Id;
        });

        return matchHasWinner(match) && (isWinner1InPositionMembers || isWinner2InPositionMembers);
    }

    return false;
};

export const hasPositionLostBySpecialOutcome = (match, positionType = 'positionOne') => {
    if (match.result) {
        const positionWon = hasPositionWon(match, positionType);

        if (positionWon) {
            return false;
        }

        const specialOutcomes = [
            OutComeTypes.DEFAULTED,
            OutComeTypes.RETIRED,
            OutComeTypes.WITHDREW,
            OutComeTypes.FORFEIT,
        ];

        return specialOutcomes.includes(match.result.outcome);
    }

    return false;
};

export const shouldDisplayWinnerAndScoreData = (match) => {
    if (match.result) {
        return matchHasWinner(match);
    }

    return false;
};
